module.exports = __webpack_public_path__ + "static/img/clearing_03.73a560ca.svg";